function getTopEdgeTriggerOffset(side, size) {
  return side === "bottom" ? size.height + size.alignOffset : size.alignOffset * -1;
}
function toNumber(styleText) {
  return parseInt(styleText, 10);
}
function getAdjustPosition(params) {
  const {
    trigger,
    availableHeight,
    contentElement,
    safeAreaOffset = 15,
    alignOffset = 0
  } = params;
  const triggerRect = trigger.getBoundingClientRect();
  const itemsHeight = contentElement.scrollHeight;
  const contentStyles = window.getComputedStyle(contentElement);
  const contentBorderTopWidth = toNumber(contentStyles.borderTopWidth);
  const contentPaddingTop = toNumber(contentStyles.paddingTop);
  const contentBorderBottomWidth = toNumber(contentStyles.borderBottomWidth);
  const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
  const contentHeight = itemsHeight + contentBorderTopWidth + contentPaddingTop + contentBorderBottomWidth + contentPaddingBottom;
  const { top: triggerRectTop, bottom: triggerRectBottom } = triggerRect;
  const triggerBottomOffset = availableHeight - triggerRectBottom;
  const sideWillBe = triggerBottomOffset < triggerRectTop ? "top" : "bottom";
  const topEdgeToTriggerOffset = getTopEdgeTriggerOffset(sideWillBe, {
    height: triggerRect.height,
    alignOffset
  }) ;
  const topEdgeToTriggerMiddle = triggerRect.top + topEdgeToTriggerOffset;
  const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
  const willTopOverflow = topEdgeToTriggerMiddle < contentHeight;
  const willBottomOverflow = triggerMiddleToBottomEdge < contentHeight;
  return [
    { willTopOverflow, willBottomOverflow },
    {
      topOffset: contentHeight - topEdgeToTriggerMiddle,
      maxHeight: (sideWillBe === "bottom" ? triggerMiddleToBottomEdge : topEdgeToTriggerMiddle) - safeAreaOffset
    }
  ];
}

export { getAdjustPosition };
//# sourceMappingURL=adjust.mjs.map
